
// 디바이스 및 브라우저 정보 추출
export const getDeviceInfo = () => {
  const ua = navigator.userAgent;
  
  // 디바이스 타입
  let deviceType = 'Desktop';
  if (/Mobile|Android|iPhone|iPad|iPod/i.test(ua)) {
    deviceType = /iPad|Tablet/i.test(ua) ? 'Tablet' : 'Mobile';
  }
  
  // OS 감지
  let os = 'Unknown';
  if (/Windows/i.test(ua)) os = 'Windows';
  else if (/Mac OS X/i.test(ua)) os = 'macOS';
  else if (/Linux/i.test(ua)) os = 'Linux';
  else if (/Android/i.test(ua)) os = 'Android';
  else if (/iOS|iPhone|iPad|iPod/i.test(ua)) os = 'iOS';
  
  // 브라우저 감지
  let browser = 'Unknown';
  if (/Chrome/i.test(ua) && !/Edge|Edg/i.test(ua)) browser = 'Chrome';
  else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = 'Safari';
  else if (/Firefox/i.test(ua)) browser = 'Firefox';
  else if (/Edge|Edg/i.test(ua)) browser = 'Edge';
  else if (/MSIE|Trident/i.test(ua)) browser = 'IE';
  
  return {
    deviceType,
    os,
    browser,
    userAgent: ua,
  };
};

// IP 기반 위치 정보 가져오기 (무료 API 사용)
export const getLocationInfo = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    
    return {
      country: data.country_name || 'Unknown',
      city: data.city || 'Unknown',
      ipAddress: data.ip || 'Unknown',
    };
  } catch (error) {
    console.error('위치 정보 가져오기 실패:', error);
    return {
      country: 'Unknown',
      city: 'Unknown',
      ipAddress: 'Unknown',
    };
  }
};

// 날짜 범위별 필터링
export const filterByDateRange = (
  data: Array<{ created_at?: string; scanned_at?: string; clicked_at?: string; viewed_at?: string }>,
  range: '7d' | '30d' | '90d' | 'all'
) => {
  if (!Array.isArray(data)) return [];
  if (range === 'all') return data;
  
  const now = new Date();
  const days = range === '7d' ? 7 : range === '30d' ? 30 : 90;
  const cutoff = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
  
  return data.filter(item => {
    const dateString = item.scanned_at || item.clicked_at || item.viewed_at || item.created_at || '';
    if (!dateString) return false;
    
    const date = new Date(dateString);
    return !isNaN(date.getTime()) && date >= cutoff;
  });
};

// 시간대별 그룹화
export const groupByHour = (
  data: Array<{ scanned_at?: string; clicked_at?: string; viewed_at?: string }>
) => {
  if (!Array.isArray(data)) return [];
  
  const hourCounts: Record<number, number> = {};
  
  for (let i = 0; i < 24; i++) {
    hourCounts[i] = 0;
  }
  
  data.forEach(item => {
    const dateString = item.scanned_at || item.clicked_at || item.viewed_at || '';
    if (!dateString) return;
    
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      const hour = date.getHours();
      hourCounts[hour] = (hourCounts[hour] || 0) + 1;
    }
  });
  
  return Object.entries(hourCounts).map(([hour, count]) => ({
    hour: parseInt(hour),
    count,
  }));
};

// 일별 그룹화
export const groupByDay = (
  data: Array<{ scanned_at?: string; clicked_at?: string; viewed_at?: string }>
) => {
  if (!Array.isArray(data)) return [];
  
  const dayCounts: Record<string, number> = {};
  
  data.forEach(item => {
    const dateString = item.scanned_at || item.clicked_at || item.viewed_at || '';
    if (!dateString) return;
    
    const date = new Date(dateString);
    if (!isNaN(date.getTime())) {
      const day = date.toISOString().split('T')[0];
      dayCounts[day] = (dayCounts[day] || 0) + 1;
    }
  });
  
  return Object.entries(dayCounts)
    .map(([day, count]) => ({ day, count }))
    .sort((a, b) => a.day.localeCompare(b.day));
};
